/* istanbul ignore file */

import { Paper, PaperProps } from '@mui/material';

export const PaddedPaper = (props: PaperProps) => {
  return (
    <Paper {...props} sx={{ padding: '20px' }}>
      {props.children}
    </Paper>
  );
};
